import { Component, input, output } from '@angular/core';
import { ToolJob, ToolParam } from '../../../../utils/models/tool.models';
import { getJobRunStatusPresentation } from '../../../../utils/job-run-presentation';
import { TimelinePreviewComponent } from '../timeline-preview/timeline-preview.component';

@Component({
  selector: 'app-result-node',
  templateUrl: './result-node.component.html',
  styleUrls: ['./result-node.component.scss'],
  imports: [TimelinePreviewComponent],
})
export class ResultNodeComponent {
  /** Inputs. */
  readonly job = input.required<ToolJob>();
  readonly parameters = input<ToolParam[]>([]);

  /** Outputs. */
  readonly activated = output();

  /** Template Forwards. */
  protected readonly presentation = getJobRunStatusPresentation;

  /** Opens completed job results. */
  activate(): void {
    if (this.job().status === 'Done') this.activated.emit();
  }

  /** Returns the failed job's error message. */
  errorMessage(): string {
    const results = this.job().results;
    return typeof results === 'string' ? results : 'Job failed.';
  }

  /** Returns structured result data when available. */
  resultData(): Record<string, unknown> | Record<string, unknown>[] | undefined {
    const results = this.job().results;
    return typeof results === 'string' ? undefined : results;
  }
}
